import React, { useState, useEffect } from 'react';
import { Grid, Card, Typography, TextField, Box } from '@mui/material';
import EventIcon from '@mui/icons-material/Event';
import dayjs from 'dayjs';
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import ColdHeat from './coldHeat.js';
import Cold from './cold.js';

const DAY_NAMES = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'];
const now = dayjs();

const Calcs = () => {

    const [date, setDate] = useState(now);
    const [time, setTime] = useState(now);
    const [num, setnum] = useState(1);
    const [txt, settxt] = useState('');

    useEffect(() => {
        calcGimelim();
    }, [num, date, time]); // eslint-disable-line react-hooks/exhaustive-deps

    const dateChange = (e) => { setDate(e); }
    const timeChange = (e) => { setTime(e); }
    const numChange  = (e) => { setnum(e.target.value); }

    // פ״מ 61.0104: ימי מנוחה נספרים מ-08:00 למחרת הקבלה (בלי קשר לשעה), כולל שישי–שבת
    const calcGimelim = () => {
        const gimelSum = parseFloat(num);
        if (isNaN(gimelSum) || gimelSum <= 0 || !date?.isValid?.()) {
            settxt('נא להזין מספר תקין');
            return;
        }

        const resultDay = date.add(gimelSum + 1, 'day');
        const dayName = DAY_NAMES[resultDay.day()];
        settxt(`${resultDay.format('D/M')} 08:00 (יום ${dayName})`);
    };

    return (
        <Box>
            <Grid container spacing={4}>

                {/* גימלים */}
                <Grid item lg={4} xs={12} sm={4}>
                    <Card
                        id="gimel"
                        sx={{ padding: '1em', display: 'flex', flexDirection: 'column', height: '19em', justifyContent: 'space-between' }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <EventIcon color="primary" />
                            <Typography variant="h5">מחשבון גימלים</Typography>
                        </Box>
                        <DatePicker
                            label="תאריך קבלת הגימלים"
                            defaultValue={now}
                            onChange={dateChange}
                            format={'DD/MM'}
                            views={['day', 'month']}
                        />
                        <TimePicker
                            label="שעת קבלת הגימלים"
                            defaultValue={now}
                            onChange={timeChange}
                            ampm={false}
                            viewRenderers={{
                                hours: renderTimeViewClock,
                                minutes: renderTimeViewClock,
                                seconds: renderTimeViewClock,
                            }}
                        />
                        <TextField
                            label="מספר הגימלים"
                            onChange={numChange}
                            defaultValue="1"
                            type="number"
                            inputProps={{ min: 1 }}
                        />
                        <Typography fontWeight="bold">
                            תוקף הגימלים עד: <span style={{ color: '#1976d2' }}>{txt}</span>
                        </Typography>
                    </Card>
                </Grid>

                {/* עומס חום */}
                <Grid item lg={4} xs={12} sm={4}>
                    <ColdHeat />
                </Grid>

                {/* עומס קור */}
                <Grid item lg={4} xs={12} sm={4}>
                    <Cold />
                </Grid>

            </Grid>
        </Box>
    );
};

export default Calcs;
